import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import './JoinWaitlist.css';

function JoinWaitlist({ onClose }) {
  const [name, setName] = useState('');
  const [stage, setStage] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'waitlist'), {
        name,
        email,
        stage,
        phone,
        message
      });
      setIsSuccess(true);
      setName('');
      setStage('');
      setEmail('');
      setPhone('');
      setMessage('');
    } catch (error) {
      console.error("Error adding to Firestore:", error);
      alert("Something went wrong. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="waitlist-shell">
        <div className="waitlist-success">
          <p className="waitlist-badge">You are in</p>
          <h2>Welcome to the Foppr waitlist</h2>
          <p>We will reach out with early access details and launch updates shortly.</p>
          <button type="button" className="submit-btn-join" onClick={() => onClose && onClose()}>
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="waitlist-shell">
      <div className="waitlist-form">
        <p className="waitlist-badge">Limited Cohort</p>
        <h2>Join the Foppr Waitlist</h2>
        <p className="waitlist-subcopy">Get priority access before public launch.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="nameinput"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Full Name"
            required
          />
          <select value={stage} className="dropteam" onChange={(e) => setStage(e.target.value)} required>
            <option value="">Your Role</option>
            <option value="product-manager">Product Manager</option>
            <option value="engineering-lead">Engineering Lead</option>
            <option value="founder">Founder/CEO</option>
            <option value="team-lead">Team Lead</option>
            <option value="other">Other</option>
          </select>
          <input
            type="email"
            className="emailfield"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Work Email"
            required
          />
          <input
            type="tel"
            className="phoneinput"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone Number (optional)"
          />
          <textarea
            className="txtarea"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Tell us about your team and where you want help."
            rows="4"
          />
          <button type="submit" className="submit-btn-join" disabled={isSubmitting}>
            {isSubmitting ? 'Securing your spot...' : 'Join Waitlist'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default JoinWaitlist;
